/* BlackoutBoxen Kategorie — Entscheidungs-Protokoll
   Scoring-Logik portiert aus eurobased-blackoutboxen.js (gleiche Matrix, gleiche sessionStorage-Keys,
   damit eine bestehende Empfehlung aus derselben Session weiterlebt). */
(function () {
  'use strict';

  var SCORING = {
    persons: {
      '1':   { essential: 3, basic: 1, premium: 0 },
      '2':   { essential: 1, basic: 3, premium: 1 },
      '3-4': { essential: 0, basic: 1, premium: 3 }
    },
    autonomy: {
      '24h': { essential: 3, basic: 1, premium: 0 },
      '72h': { essential: 1, basic: 3, premium: 1 },
      '96+': { essential: 0, basic: 1, premium: 3 }
    },
    existing: {
      'none':    { essential: 0, basic: 2, premium: 3 },
      'partial': { essential: 1, basic: 3, premium: 1 },
      'yes':     { essential: 3, basic: 1, premium: 0 }
    },
    priority: {
      'budget':   { essential: 3, basic: 1, premium: 0 },
      'balanced': { essential: 1, basic: 3, premium: 1 },
      'full':     { essential: 0, basic: 1, premium: 3 }
    }
  };

  var NAMES = { essential: 'Essential', basic: 'Basic', premium: 'Premium' };
  var STORE_KEY = 'eb_finder_recommendation';
  var STORE_ANSWERS = 'eb_finder_recommendation_answers';

  function calculateResult(answers) {
    var scores = { essential: 0, basic: 0, premium: 0 };
    Object.keys(answers).forEach(function (q) {
      var a = answers[q];
      if (a && SCORING[q] && SCORING[q][a]) {
        scores.essential += SCORING[q][a].essential;
        scores.basic += SCORING[q][a].basic;
        scores.premium += SCORING[q][a].premium;
      }
    });
    // Höchste Punktzahl gewinnt, bei Gleichstand: Basic
    if (scores.premium > scores.basic && scores.premium > scores.essential) return 'premium';
    if (scores.essential > scores.basic && scores.essential > scores.premium) return 'essential';
    return 'basic';
  }

  function init() {
    var quiz = document.querySelector('[data-bbx-quiz]');
    if (!quiz) return;

    var answers = {};
    var urls = {};
    try { urls = JSON.parse(quiz.querySelector('[data-bbx-urls]').textContent); } catch (e) { urls = {}; }

    var resultPanel = quiz.querySelector('[data-bbx-result]');
    var resultName = quiz.querySelector('[data-bbx-result-name]');
    var resultCta = quiz.querySelector('[data-bbx-result-cta]');

    function clearBadges() {
      document.querySelectorAll('[data-bbx-badge]').forEach(function (b) { b.hidden = true; });
      document.querySelectorAll('[data-bbx-profile]').forEach(function (p) { p.classList.remove('is-reco'); });
      document.querySelectorAll('[data-bbx-table]').forEach(function (t) { t.removeAttribute('data-bbx-reco'); });
    }

    function showResult(tier) {
      if (!tier) return;
      if (resultCta) {
        resultCta.href = urls[tier] || '#';
        var label = resultCta.querySelector('[data-bbx-result-cta-label]');
        if (label) label.textContent = 'Zur ' + (NAMES[tier] || tier);
      }
      /* Erst aufdecken, dann Text in den naechsten Frame schreiben — sonst
         verpassen Screenreader die aria-live-Aenderung beim hidden-Wechsel. */
      if (resultPanel) resultPanel.hidden = false;
      if (resultName) {
        var setName = function () { resultName.textContent = NAMES[tier] || tier; };
        if (window.requestAnimationFrame) { requestAnimationFrame(setName); } else { setName(); }
      }
      clearBadges();
      var badge = document.querySelector('[data-bbx-badge="' + tier + '"]');
      if (badge) badge.hidden = false;
      var profile = document.querySelector('[data-bbx-profile="' + tier + '"]');
      if (profile) profile.classList.add('is-reco');
      document.querySelectorAll('[data-bbx-table]').forEach(function (t) { t.setAttribute('data-bbx-reco', tier); });
    }

    function maybeFinish() {
      if (answers.persons && answers.autonomy && answers.existing && answers.priority) {
        var tier = calculateResult(answers);
        try {
          sessionStorage.setItem(STORE_KEY, tier);
          sessionStorage.setItem(STORE_ANSWERS, JSON.stringify(answers));
        } catch (e) { /* Storage gesperrt — Ergebnis trotzdem zeigen */ }
        showResult(tier);
        if (resultPanel && typeof resultPanel.scrollIntoView === 'function') {
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          resultPanel.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
    }

    quiz.querySelectorAll('[data-bbx-q]').forEach(function (row) {
      var key = row.getAttribute('data-bbx-q');
      row.querySelectorAll('.bbx-cmp__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers[key] = btn.getAttribute('data-bbx-val');
          row.querySelectorAll('.bbx-cmp__opt').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          maybeFinish();
        });
      });
    });

    var reset = quiz.querySelector('[data-bbx-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        answers = {};
        try {
          sessionStorage.removeItem(STORE_KEY);
          sessionStorage.removeItem(STORE_ANSWERS);
        } catch (e) { /* noop */ }
        quiz.querySelectorAll('.bbx-cmp__opt').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        if (resultPanel) resultPanel.hidden = true;
        clearBadges();
      });
    }

    // Empfehlung aus derselben Session wiederherstellen
    try {
      var saved = sessionStorage.getItem(STORE_KEY);
      var savedAnswers = JSON.parse(sessionStorage.getItem(STORE_ANSWERS) || 'null');
      if (saved && savedAnswers) {
        answers = savedAnswers;
        Object.keys(savedAnswers).forEach(function (key) {
          var row = quiz.querySelector('[data-bbx-q="' + key + '"]');
          if (!row) return;
          var btn = row.querySelector('.bbx-cmp__opt[data-bbx-val="' + savedAnswers[key] + '"]');
          if (btn) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
        });
        showResult(saved);
      }
    } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme-Editor: Section-Rerender ersetzt das DOM — Quiz neu binden */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bbx-quiz]')) init();
  });
})();
